import { Button } from '@material-ui/core';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';

import { SignUpEmailContainer } from '../sign-up-email';
import { MatField } from 'src/core/components/mat-field';
import { PageError } from 'src/core/components/page-error/page-error';

const emailErrorMap = {
    required: null,
    email: null,
};

interface Props {
    container: SignUpEmailContainer;
}

export const SignUpEmail = observer<React.SFC<Props>>(({ container: { data } }) => (
    <div className="page page-inverted login-image-background">
        <div className="page-topping">
            <PageError
                absolute
                messageClass={data.emailSent ? 'page-note' : ''}
                message={data.message}
                onClose={data.clearError}
            />
        </div>

        <div className="card">
            <form className="flex-form" onSubmit={data.handleSubmit}>
                <h1>Verify your email</h1>
                <div className="card-content">
                    <p>Enter the email address associated with your account.</p>
                    <div className={classnames('form-field', 'single-input')}>
                        <MatField
                            fullWidth
                            type="email"
                            name="email"
                            placeholder="Email"
                            fieldState={data.email}
                            errorMap={emailErrorMap}
                            disabled={data.emailSent}
                            autoFocus
                        />
                    </div>
                </div>
                <div className="space-filler" />
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className="next-step-button"
                    disabled={data.form.hasError || data.emailSent}
                >
                    Submit
                </Button>
            </form>
        </div>
    </div>
));
